import BaseApi from "../../../BaseApi";

export default class ManageAbsences extends BaseApi {

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "absences/manage/";
    }

    static async listUsers(filters={}) {
        return this.get(
            `${this.getApiUrl()}list/users`,
            {
                params: filters,
            },
        );
    }

    static async updateUserDefaultVacationDays(id, payload) {
        return this.patch(
            `${this.getApiUrl()}users/${id}/default-vacation-days`,
            payload,
        );
    }

    static async listDefaultDaysByUser(filters={}) {
        return this.get(
            `${this.getApiUrl()}list/default-days/by-user`
        )
    }

    static async getDefaulDaysByUser(id) {
        return this.get(
            `${this.getApiUrl()}default-days/${id}`
        );
        
    }

    static async deleteDefaultDaysByUser(id) {
        return this.delete(
            `${this.getApiUrl()}default-days/${id}`
        )
    }

    static async updateDefaultDaysByUser(id, payload) {
        return this.delete(
            `${this.getApiUrl()}default-days/${id}`,
            payload
        );
    }
}